import { render, staticRenderFns } from "./PdpaMkt.vue?vue&type=template&id=a7fd8cc2&scoped=true&"
import script from "./PdpaMkt.vue?vue&type=script&lang=js&"
export * from "./PdpaMkt.vue?vue&type=script&lang=js&"
import style0 from "./PdpaMkt.vue?vue&type=style&index=0&id=a7fd8cc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7fd8cc2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VBtn,VRadio,VRadioGroup})
